import namedModuleGenerator from '../profile-action'

const setupPicoLinkActionsModule = namedModuleGenerator({
    name: 'setupPicoLink',
})

export default setupPicoLinkActionsModule
